import { IconButton, styled } from '@mui/material';
import theme from 'App.theme';

export const NavigationContainer = styled('nav')<{ compact: boolean }>(({ theme, compact }) => ({
  height: '100vh',
  width: compact ? '80px' : '140px',
  boxShadow: `5px 0 20px ${theme.greys.GREY0}`,
  display: 'flex',
  flexDirection: 'column',

  '& .logo-container': {
    width: '100%',
    overflow: 'hidden',
    textAlign: 'center',
    padding: '20px',

    '& img': {
      maxWidth: '100%',
      transform: `scale(${compact ? 1.3 : 1})`,
    },

    '&:hover': {
      cursor: 'pointer',
    },
  },
}));

export const NavButtonContainer = styled('div')`
  width: 100%;
  padding: 3rem 1rem;
`;

export const AvatarButton = styled(IconButton)`
  margin-top: auto;
  padding-bottom: 10px;
`;

export const NavLinksContainer = styled('nav')`
  margin: 0;
  padding-bottom: 10px;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 0;
  }
`;

export const ActionPillsContainer = styled('div')`
  display: flex;
  gap: ${theme.layout.spacing.small};
  padding: ${theme.layout.spacing.small};
  align-items: center;
`;

type NavListItemProps = {
  active?: boolean;
};

export const NavListItem = styled('li')<NavListItemProps>`
  font-size: 17px;
  font-weight: 300;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${props => (props.active ? theme.colours.white : theme.colours.black)};
  background-color: ${props => (props.active ? theme.colours.active : theme.colours.white)};
  transition: all 0.3s;
  margin: 0;
  padding: 22px 10px;
  width: 100%;

  & .menu-icon,
  .menu-icon-path-fill {
    width: 32px;
    height: 32px;
    margin-bottom: 4px;
  }

  .menu-icon path {
    fill: ${props => (props.active ? theme.colours.white : theme.colours.black)};
  }

  & .delivery-truck path {
    stroke: ${props => (props.active ? theme.colours.white : theme.colours.black)};
    stroke-width: 10px; /* Example dynamic stroke-width */
  }

  & .menu-icon,
  .menu-icon-path-fill path {
    fill: ${props => (props.active ? theme.colours.white : theme.colours.black)};
  }
`;

export const NavListLogout = styled(NavListItem)<NavListItemProps>`
  margin-top: auto;
  display: flex;
  flex-direction: column;
  gap: ${theme.layout.spacing.medium};
`;

export const NavListAvatar = styled(NavListItem)<NavListItemProps>`
  margin-top: auto;
`;
